import * as singleSpa from 'single-spa' // 导入single-spa
import registerApplication from './.spa/registerApplication'
import appConfig from './.spa/app-config.json'

setTimeout(function () {
  registerApplication(appConfig.apps)

  window.addEventListener('single-spa:before-app-change', (evt) => {
    console.log('single-spa is about to mount/unmount applications!')
    console.log(evt.detail.originalEvent) // PopStateEvent
    console.log(evt.detail.newAppStatuses) // { app1: MOUNTED }
    console.log(evt.detail.appsByNewStatus) // { MOUNTED: ['app1'], NOT_MOUNTED: [] }
    console.log(evt.detail.totalAppChanges) // 1
    document.getElementById('vue').className = ((evt.detail.appsByNewStatus || {}).MOUNTED || []).join(' ')
  })

  // 启动
  singleSpa.start({
    urlRerouteOnly: true,
  })
}, 300)
